var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49907 2.206L3.54174 6.13333C3.09574 6.576 3.41174 7.33333 4.04307 7.33333H11.9571C12.5884 7.33333 12.9044 6.576 12.4577 6.13333L8.50107 2.206C8.22374 1.93133 7.77574 1.93133 7.49907 2.206ZM8.5004 13.794L12.4571 9.86667C12.9031 9.424 12.5871 8.66667 11.9564 8.66667H4.04307C3.41174 8.66667 3.09574 9.424 3.5424 9.86667L7.49907 13.794C7.77574 14.0687 8.22374 14.0687 8.5004 13.794Z",
    fill: "#858994"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort);
export default __webpack_public_path__ + "static/media/icon_sort.516434af96e78c03d8df626aab42f6fd.svg";
export { ForwardRef as ReactComponent };